import { Environment } from '@src/config/environment';
import { secureFetch } from '../secureFetch';
import { ApiError } from './ApiError';

export class HttpClient {
  async fetchRaw(path: string, options: RequestInit) {
    const response = await secureFetch(
      `${Environment.DIRECTUS_API_URL}/${path}`,
      {
        ...options,
        headers: { ...options.headers, Accept: 'application/json' },
        credentials: 'include',
      },
    );

    if (!response.ok) {
      const text = await response.text();
      throw new ApiError(
        `Failed to fetch ${path}: ${text}`,
        path,
        response.status,
      );
    }
    return response;
  }

  async fetch<T>(path: string, options: RequestInit) {
    const response = await this.fetchRaw(path, options);
    // No Content
    if (response.status === 204 || response.status === 202) {
      return;
    }
    return response.json() as Promise<T>;
  }
}
